import campaignServices from 'services/campaignServices';

export const campaignActions = {
  searchCampaign: 'searchCampaign',
};

export default {
  [campaignActions.searchCampaign]: {
    saga: function*({ payload = {} }) {
      const { callbacks, body = {} } = payload;
      try {
        const response = yield campaignServices.searchCampaign(body);
        callbacks && callbacks.onSuccess(response);
      } catch (error) {
        callbacks && callbacks.onFailed(error);
      }
    },
  },
};
